import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { TrimNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-trim',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-trim.component.html',
  styleUrl: './edit-trim.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditTrimComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTrimComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<TrimNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.TRIM.NAME'), [Validators.required]],
    start: [null, [Validators.required]],
    end: [null, [Validators.required]],
    pad: [null],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        pad: this.selectedNodeForEdit().data.pad ?? null,
        start: this.selectedNodeForEdit().data.start,
        end: this.selectedNodeForEdit().data.end,
      })
    }
  }
}
